import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { readSections, writeSections } from './sectionStorage';

// Clickable-header wrapper for the status page's table sections. Expanded state
// is remembered per sectionKey in localStorage; keys never seen before default
// to expanded so new sections always start open.
class CollapsibleSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: readSections()[props.sectionKey] !== false };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    const { sectionKey } = this.props;
    this.setState(({ expanded }) => {
      const next = !expanded;
      writeSections({ ...readSections(), [sectionKey]: next });
      return { expanded: next };
    });
  }

  render() {
    const { title, children, className } = this.props;
    const { expanded } = this.state;
    return (
      <div className={className}>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <h3 onClick={this.handleToggle} style={{ cursor: 'pointer', userSelect: 'none' }}>
          <Icon
            type={expanded ? 'caret-down' : 'caret-right'}
            style={{ marginRight: 6, fontSize: 12 }}
          />
          {title}
        </h3>
        {expanded ? children : null}
      </div>
    );
  }
}

CollapsibleSection.propTypes = {
  sectionKey: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

CollapsibleSection.defaultProps = {
  className: '',
  children: null
};

export default CollapsibleSection;
